// DEPENDENCIES
import React, { Component } from 'react';
import { connect } from 'react-redux';

// import { Link } from 'react-router';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline"

// import { Pagination } from 'react-bootstrap';
import $ from 'jquery';
import { browserHistory } from 'react-router';

// import Gallery from 'react-grid-gallery';

// actions
import {
    getUserLocation,
    loginTemp,
    openParticipateModal,
    openSubmitModalRequest,

} from "../../Actions/users";
import {
    openBandFinderPinModal,
    openPinModal,
    updateFilters,
    incPinViewCount
} from '../../Actions/main';

// services
import { AnalyticsService } from "../../Services";

// INNER IMPORTS
import { ENROL_TYPE_FREE, ENROL_TYPE_MEDIUM, ENROL_TYPE_HIGH, ENROL_TYPE_HUGE } from '../../Models/consts';
import {isBandFinderType, capitalizeAll, isMobile, formatPrices, getDate, isCharHebrew} from '../../utils'
import { LIVE_MUSIC, SERVICE } from '../../consts'
import getSymbolFromCurrency from 'currency-symbol-map';
import { clientMedia } from "../../Config/Settings";
import { PinCounterAnimated } from "../Elements/PinCounters";

// styles
import './Mosaic.css';

// svgs
import doubleArrow from "../inlineSVGs/doubleArrow";
import lightningSVG from "../inlineSVGs/lightningSVG";
import {RandomIcons} from "../Elements/Decorations";
import smallStarSVG from "../inlineSVGs/smallStarSVG";

import {closePinFullViewModal, openPinFullViewModal} from "../../Actions/modals";
import lineEyeSVG from "../inlineSVGs/lineEyeSVG";

class Mosaic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            isMore: false
        };

    }

    // updateHeight() {
    //     const height = this.divElement.clientHeight;
    //     console.log('height updated', height);
    //
    //     this.divElement.style.maxHeight = `${height}px`
    // }


    // This function returns all image fields for each pin
    // MOBILE pin sorting
    getSortedPinsMobile(pinsList) {
        if (!pinsList) return [];

        // creating new pinsNew array so that reordering wont effect the parent component list
        const { freePins, midPins, highPins, hugePins } = this._sortPins(pinsList);

        // reordering each pin group by the bounce date
        highPins.sort((a, b) => {
            return a.bounceDate < b.bounceDate ? 1 : -1;
        });

        midPins.sort((a, b) => {
            return a.bounceDate < b.bounceDate ? 1 : -1;
        });

        if (this.props.filters.type === LIVE_MUSIC) {
            freePins.sort((a, b) => {
                if (a.date === b.date) {
                    if (a.time !== b.time) return a.time > b.time ? 1 : -1;

                    if (a.bounceDate !== b.bounceDate) return a.bounceDate > b.bounceDate;
                    if (a.lastBounceDate !== b.lastBounceDate) return a.lastBounceDate > b.lastBounceDate;
                    if (a.publishDate!== b.publishDate) return a.publishDate> b.publishDate;
                    if (a.location.position.lat!== b.location.position.lat) return a.location.position.lat> b.location.position.lat;

                    return a.name.length > b.name.length;
                }

                return a.date > b.date ? 1 : -1;
            }); // liveMusic ads sorted by event date only for now
        } else {
            freePins.sort((a, b) => a.bounceDate < b.bounceDate ? 1 : -1 ); // all other ads sorted with normal bounce date
        }

        hugePins.sort((a, b) => {
            return a.bounceDate < b.bounceDate ? 1 : -1;
        });

        return [...hugePins, ...highPins, ...midPins, ...freePins];
    }

    // WEB pin sorting
    getSortedPinsWeb(pinsList) {
        if (!pinsList || pinsList.length < 1) return [];

        // creating new pinsNew array so that reordering wont effect the parent component list
        const { freePins, midPins, highPins, hugePins } = this._sortPins(pinsList);

        // reordering each pin group by the bounce date
        highPins.sort((a, b) => a.bounceDate < b.bounceDate ? 1 : -1);

        midPins.sort((a, b) => a.bounceDate < b.bounceDate ? 1 : -1 );

        if (this.props.filters.type === LIVE_MUSIC) {
            freePins.sort((a, b) => {
                if (a.date === b.date) {
                    if (a.time !== b.time) return a.time > b.time ? 1 : -1;

                    if (a.bounceDate !== b.bounceDate) return a.bounceDate > b.bounceDate;
                    if (a.lastBounceDate !== b.lastBounceDate) return a.lastBounceDate > b.lastBounceDate;
                    if (a.publishDate!== b.publishDate) return a.publishDate> b.publishDate;
                    if (a.location.position.lat!== b.location.position.lat) return a.location.position.lat> b.location.position.lat;

                    return a.name.length > b.name.length;
                }

                return a.date > b.date ? 1 : -1;

            }); // liveMusic ads sorted by event date only for now

        } else {
            freePins.sort((a, b) => a.bounceDate < b.bounceDate ? 1 : -1 ); // all other ads sorted with normal bounce date
        }

        hugePins.sort((a, b) => a.bounceDate < b.bounceDate ? 1 : -1 );

        return [...hugePins, ...highPins, ...midPins, ...freePins];
    }

    _sortPins(pinsList) {
        // creating new pinsNew array so that reordering wont effect the parent component list
        let freePins = pinsList.filter((pin) => {
            return pin.subscription.enrolType === ENROL_TYPE_FREE && !pin.subscription.upgrade
        });

        let midPins = pinsList.filter((pin) => {
            if (pin.subscription.enrolType === ENROL_TYPE_MEDIUM && !pin.subscription.upgrade) return true;

            return pin.subscription.upgrade === 'mid';
        });

        let highPins = pinsList.filter((pin) => {
            if (pin.subscription.enrolType === ENROL_TYPE_HIGH && !pin.subscription.upgrade) return true;

            return pin.subscription.upgrade === 'high';
        });

        let hugePins = pinsList.filter((pin) => {
            if (pin.subscription.enrolType === ENROL_TYPE_HUGE && !pin.subscription.upgrade)  {

                return true
            }

            return pin.subscription.upgrade === 'huge';
        });

        return { freePins, midPins, highPins, hugePins }
    }

    // After clicking pin the event popup should open
    openEvent(pin) {
        if (!pin) return;

        if (window && window.history && !isMobile()) {
            window.history.pushState('', '', `pages/${pin._id}`);
            this.props.openPinFullViewModal(pin);

            return;
        }

        browserHistory.push(`/#${pin.type}`);

        // for mobile view use old pin view adapted to mobile
        //if (pin.type === LIVE_MUSIC || pin.type === SERVICE) return this.props.openPinModal(pin);

        this.props.openPinFullViewModal(pin)
    }

    onOpenEventClick(pin, index) {
        if (pin.name) {
            this.openEvent(pin);

            this.props.incPinViewCount(pin._id);

            AnalyticsService.sendEvent(AnalyticsService.events.OPEN_PIN, `${pin.type}_${pin.category}`, null, {
                pin_type: pin.type,
                pin_category: pin.category,
            });
            return;
        }

        return null;
    }

    isMobileFocus() {
        if (!isMobile()) return '';
    }

    setBoxStyle(pin) {
        if ($.isEmptyObject(pin) || !pin.name) return null;

        const style = {};
        const imageUrl = this._getImageUrl(pin);

        if (imageUrl) {
            style.backgroundImage = `url(${imageUrl})`;
        } else {
            style.backgroundImage = `url(${clientMedia()}/img/logos/make-logo.png)`;
            style.backgroundSize = 'contain'
        }

        return style;
    }

    formatCardTitle(str, maxLength) {
        if (maxLength < 25) return str

        const shortenedStr = `${str.substring(0, 25)}`;
        return isCharHebrew(shortenedStr) ? `...${shortenedStr}` : `${shortenedStr}...`
    }

    _getImageUrl(pin) {
        if ($.isEmptyObject(pin) || !pin.name) return '';

        let imageUrl = pin.images && pin.images[0] && pin.images[0].src ? pin.images[0].src : '';

        return imageUrl
    }

    getSubCatBandFinderName(catName) {

        if (!this.props.datatypes || !this.props.datatypes.categories[this.props.filters.type]) return '';
        const catObj = this.props.datatypes.categories[this.props.filters.type].find(cat => cat.name === catName) || {};

        return capitalizeAll(catObj.text);
    }

    renderPrices(pin) {
        if (pin.prices) {
            if (pin.prices.price) {
                return (
                    <div className="text">
                        {`${pin.prices.price} ${getSymbolFromCurrency(pin.prices.currency)}`}
                    </div>
                )
            }

            if (pin.prices.min && pin.prices.max) {
                return (
                    <div className="text">
                        {`${pin.prices.min}-${pin.prices.max} ${getSymbolFromCurrency(pin.prices.currency)}`}
                    </div>
                )
            }

            return (
                <div className="text">
                    {pin.prices.priceType === 'hat' ? 'HAT' : 'FREE'}
                </div>
            )
        }
    }

    // TODO: not in use for now
    renderSubTypeLabel(pin) {
        if (!pin || !pin.subscription || !pin.subscription.enrolType) return null;

        // const subType = pin.subscription.enrolType;
        // let subTypeText = 'Free Ad';
        // if (subType === 'push') subTypeText = 'Push Ad';
        // if (subType === 'rule') subTypeText = 'Rule Ad';
        // if (subType === 'huge') subTypeText = 'Super Ad';
    }

    // TODO: for case client regrets again - leaving those here
    // <div className="time">{getDate(pin.date, pin.time)}</div>
    // <div className="price">{this.renderPrices(pin)}</div>
    renderCard(pin, enrolType) {
        if ($.isEmptyObject(pin) || !pin.type) return null;

        if (pin.type === LIVE_MUSIC) {
            return (
                <div className={`info rtl ${pin.subCategories.length > 1 ? 'multiple-sub-cats-mobile' : ''}`}>
                    <div className="center-wrapper">
                        <div className="name">{this.formatCardTitle(pin.name, pin.name.length)}</div>
                        <div className="location">{pin.location && pin.location.city}</div>
                        <div className="box-time">{getDate(pin.date, pin.time)}</div>
                    </div>
                    <div className="bottom-wrapper rtl">
                        <div className="cats-bottom-wrapper">
                            <div className={`subCategory price-label ${pin.type}`}>{formatPrices(pin.prices)}</div>
                            {pin.subCategories.map((subcategory, index)=> {
                                return (
                                    <div key={"subCategory" + index} className={`subCategory ${pin.type}`}>{subcategory}</div>
                                )
                            })}
                        </div>
                        {pin.interactions && pin.interactions.viewsCount ?
                            <div className="views-count-wrapper rtl">
                                <p><SVGInline svg={lineEyeSVG} className={`line-eye-icon`} component="i"/></p>
                                <p className={'views-label'}>{pin.interactions.viewsCount} <span>צפיות</span></p>

                            </div> : null
                        }
                    </div>

                </div>
            )
        }

        // <div className="price">{this.renderPrices(pin)}</div>
        if (pin.type === SERVICE) {
            const catType = this.props.datatypes && this.props.datatypes.categories.service.find(d => d.name === pin.category);

            return (
                <div className="info rtl">
                    <div className="center-wrapper">
                        <div className="name">{this.formatCardTitle(pin.name, pin.name.length)}</div>
                        <div className="location">{pin.location.city}</div>
                    </div>
                    <div className={`bottom-wrapper rtl inner-${enrolType}`}>
                        <div className="cats-bottom-wrapper">
                            <div className={`subCategory price-label ${pin.type}`}>{formatPrices(pin.prices)}</div>

                            {!this.props.filters.category && catType
                                ? <div className={`subCategory ${pin.type}`}>{catType.text}</div>
                                :
                                pin.subCategories.map((subcategory, index)=> {
                                    return (
                                        <div key={"subCategory" + index} className={`subCategory ${pin.type}`}>{subcategory}</div>
                                    )
                                })
                            }
                        </div>
                        {pin.interactions && pin.interactions.viewsCount ?
                            <div className="views-count-wrapper rtl">
                                <p><SVGInline svg={lineEyeSVG} className={`line-eye-icon`} component="i"/></p>
                                <p className={'views-label rtl'}>{pin.interactions.viewsCount} <span>צפיות</span></p>

                            </div> : null
                        }
                    </div>
                </div>
            )
        }


        if (isBandFinderType(pin.type)) {
            return (
                <div className="info rtl">
                    <div className="center-wrapper">
                        <div className="name">{this.formatCardTitle(pin.name, pin.name.length)}</div>
                        <div className="location">{pin.location.city}</div>
                    </div>

                    <div className={`bottom-wrapper rtl inner-${enrolType}`}>
                        <div className="cats-bottom-wrapper">
                            <div className={`subCategory ${pin.type}`}>{this.getSubCatBandFinderName(pin.iWeAre)}</div>
                        </div>
                        {pin.interactions && pin.interactions.viewsCount ?
                            <div className="views-count-wrapper rtl">
                                <p><SVGInline svg={lineEyeSVG} className={`line-eye-icon`} component="i"/></p>
                                <p className={'views-label'}>{pin.interactions.viewsCount} <span>צפיות</span></p>

                            </div> : null
                        }
                    </div>
                </div>
            )
        }

        return null;
    }

    renderEmptyCard(color, index) {
        if (isMobile()) return null;

        // YOU ARE UP NEXT!
        // Submit Now!
        if (this.props.filters.type === LIVE_MUSIC) {
            return (
                <div className={`box card empty-card ${color}`} key={`pin-live-${index}`}>
                    <div
                        className={`boxContent empty-box ${this.props.filters.type}`}
                        onClick={() => this.props.openSubmitModalRequest(this.props.filters.type)}
                    >

                        <div className="info empty-box">
                            <span className="empty-card-title">אתם הבאים בתור!</span>
                        </div>

                        <div className="submit-wrapper">
                            <span className="empty-card-cta">פרסמו עכשיו!</span>
                        </div>

                        <div className="image-wrapper">
                            <img src="https://media.mugics.com/img/logos/glasses-mugics.png" alt="glasses-mugics"/>
                        </div>
                        <RandomIcons
                            isLoopMove
                            iconSVG={smallStarSVG}
                            numIcons={50}
                            leftLimit={-400}
                            rightLimit={500}
                            topLimit={0}
                            bottomLimit={0}
                        />
                    </div>
                </div>
            )
        }

        if (this.props.filters.type === SERVICE) {
            return (
                <div className={`box card empty-card ${color}`} key={`pin-live-${index}`}>
                    <div className={`boxContent empty-box ${this.props.filters.type}`} onClick={() => this.props.openSubmitModalRequest('service')}>
                        <div className="info empty-box">
                            <span className="empty-card-title">אתם</span> <br/>
                            <span className="empty-card-content">הבאים</span><br/>
                            <span className="empty-card-content">בתור!</span><br/>
                        </div>

                        <div className="submit-wrapper">
                            <span className="empty-card-cta">פרסמו עכשיו!</span>
                        </div>

                        <div className="image-wrapper">
                            <img src="https://media.mugics.com/img/logos/glasses-mugics.png" alt="glasses-mugics"/>
                        </div>
                    </div>
                </div>
            )
        }

        return null;
    }

    renderList(newPins) {
        let colorPick = 0;

        let rulePinsCount = 0;
        const sortedPins = [...newPins];

        return sortedPins.map((pin, index) => {
            if (!pin) return null;

            let enrolType = '';
            if (Object.keys(pin).length > 0) {
                // choosing randomly between 4 colors for the blank pinsNew
                const colors = ['first-color', 'second-color', 'third-color', 'forth-color'];
                enrolType = colors[colorPick];
                colorPick++;

                if (colorPick > 3) colorPick = 0;

                if (enrolType === 'first-color') {
                    // return this.renderEmptyCard(enrolType, index);
                }
            }
            let isRuleToPush;

            if (Object.keys(pin).length > 0 && Object.keys(pin.subscription || {}).length > 0 && pin.subscription.enrolType) {

                const prevPin = sortedPins[index - 1];

                let prevPinEnrollType;
                if (prevPin) {
                    prevPinEnrollType = prevPin.subscription.enrolType;
                    if (prevPin.subscription.upgrade && prevPin.subscription.upgrade !== 'none') {
                        prevPinEnrollType = prevPin.subscription.upgrade;
                    }
                }

                switch (pin.subscription.enrolType) {
                    case ENROL_TYPE_FREE:
                        enrolType = 'free';
                        break;
                    case ENROL_TYPE_MEDIUM:
                        enrolType = 'mid';
                        break;
                    case ENROL_TYPE_HIGH:
                        enrolType = 'high';
                        break;
                    case ENROL_TYPE_HUGE:
                        enrolType = 'huge';
                        break;
                    default: enrolType = '';
                }

                if (pin.subscription.upgrade && pin.subscription.upgrade !== 'none') {
                    enrolType = pin.subscription.upgrade;
                }

                if (enrolType === ENROL_TYPE_HIGH) rulePinsCount++;

                // Rule on left side following one Push and then Free use case
                if (enrolType === ENROL_TYPE_MEDIUM && prevPinEnrollType === ENROL_TYPE_HIGH) {
                    isRuleToPush = rulePinsCount % 2 > 0
                }
                // Rule on left side then Free use case
                if (enrolType === ENROL_TYPE_FREE && prevPinEnrollType === ENROL_TYPE_HIGH) {
                    isRuleToPush = rulePinsCount % 2 > 0
                }
            }

            if (isRuleToPush) {
                return [
                    this.renderEmptyCard('first-color end-paid', index),
                    <div className={`box card ${this.isMobileFocus()} ${enrolType}`} key={"pin" + index}>
                        <div className={`boxContent`}
                             style={this.setBoxStyle(pin)}
                             onClick={() => this.onOpenEventClick(pin, index)}
                        >
                            <div className="box-gradient-wrapper">
                                {this.renderSubType(pin.subscription)}

                                {this.renderCard(pin, enrolType)}
                            </div>
                        </div>
                    </div>
                ]
            }

            return (
                <div className={`box card ${this.isMobileFocus()} ${enrolType}`} key={"pin" + index}>
                    <div className={`boxContent`}
                         style={this.setBoxStyle(pin)}
                         onClick={() => this.onOpenEventClick(pin, index)}
                    >
                        <div className="box-gradient-wrapper">
                            {this.renderSubType(pin.subscription)}

                            {this.renderCard(pin, enrolType)}
                        </div>

                    </div>
                </div>
            )
        });
    }

    renderSubType (subObj) {
        if (!subObj) return null;

        let enrolTypeText = '';
        let superType ='';
        if (subObj.enrolType === 'free' && (!subObj.upgrade || subObj.upgrade === 'none')) return null;

        if (subObj.enrolType === 'mid' || subObj.upgrade === 'mid') enrolTypeText = 'Push Ad';

        if (subObj.enrolType === 'high' || subObj.upgrade === 'high') enrolTypeText = 'Rule Ad';

        if (subObj.enrolType === 'huge' || subObj.upgrade === 'huge') {
            enrolTypeText = 'Super Ad';
            superType = 'huge-type';
        }

        if (!enrolTypeText) return null;

        return (
            <label className={`pin-enrol-type-label ${subObj.upgrade || subObj.enrolType} ${superType}`}>
                {enrolTypeText}
                {superType ? <SVGInline svg={lightningSVG} className={`green-arrow-icon`} component="i"/> : null}
            </label>
        )
    }

    handleClickMore() {
        this.setState({activePage: this.state.activePage ? this.state.activePage + 1 : 1});

        this.props.updateFilters({pageNumber: this.props.filters.pageNumber + 1});

        // TODO: update filters new method TBD with new page number - getPins() request will be triggred from TopBAR
        this.props.paginationHandler(this.state.activePage + 1);
    }

    renderMoreSection() {
        if (!this.props.pages || this.props.pages <= 1) return null;

        return (
            <div className={`more-section-wrapper ${this.props.filters.type}`}>
                <div className="more-text">Load More</div>
                <button className="button-more" onClick={() => this.handleClickMore()}>
                    <SVGInline
                        svg={doubleArrow(this.props.filters.type === SERVICE ? '#250e47' : '#FFFFFF')}
                        className={`double-arrow-icon`}
                        component="i"
                    />
                </button>
            </div>
        )
    }

    // TODO: not in use TBR
    renderPagination() {
        // if (this.props.pages <= 1) return null;

        return (
            <div className="pagination-wrapper">
                {this.renderMoreSection()}
                {/*<Pagination*/}
                    {/*prev*/}
                    {/*next*/}
                    {/*first*/}
                    {/*last*/}
                    {/*ellipsis*/}
                    {/*boundaryLinks*/}
                    {/*items={this.props.pages}*/}
                    {/*maxButtons={4}*/}
                    {/*activePage={this.state.activePage}*/}
                    {/*onSelect={this.handleClickMore.bind(this)}*/}
                {/*/>*/}
            </div>
        )
    }

    render() {
        if (!this.props || !this.props.datatypes) return null;
        const newPins = isMobile() ? this.getSortedPinsMobile(this.props.pinsNew) : this.getSortedPinsWeb(this.props.pinsNew);

        return (
            <div
                className="mosaic"
                style={{
                    display: !isMobile() || this.props.mode === "gallery" ? "block" : "none"
                }}
                // ref={ divElement => {this.divElement = divElement; console.log('is this rendring??')}}
            >
                {isMobile() && this.props.mode === 'gallery' ?
                    <PinCounterAnimated
                        startCountAnimation
                        type={this.props.filters.type}
                        defaults={this.props.datatypes.defaults || {}}
                        countryPinCount={this.props.countryPinCount || {}}
                        chosenDateLabel={this.props.chosenDateLabel || 'soon'}
                    /> : null }

                <div className="wrapper">
                    {/*{this.renderPagination()}*/}
                    {this.renderList(newPins)}
                    {this.renderMoreSection(newPins)}
                </div>
            </div>
        )
    }
}

Mosaic.propTypes = {
    openSubmitModalRequest: PropTypes.func,
    openPinModal: PropTypes.func,
    openPinFullViewModal: PropTypes.func, // new pin modal
    openBandFinderPinModal: PropTypes.func,
    pinsNew: PropTypes.array,
    updateFilters: PropTypes.func,
    filters: PropTypes.object,
    mode: PropTypes.string,
    pages: PropTypes.number,
    paginationHandler: PropTypes.func,
    route: PropTypes.string,
    datatypes: PropTypes.object,
    chosenDateLabel: PropTypes.string,
    countryPinCount: PropTypes.object,
    incPinViewCount: PropTypes.func
};

const mapStateToProps = state => ({
    pinsNew: state.main.pinsNew,
    pages: state.main.pages,
    filters: state.main.filters,
    mode: state.main.mode,
    datatypes: state.main.datatypes,
    route: state.routing.locationBeforeTransitions.pathname,
    chosenDateLabel: state.main.chosenDateLabel,
    countryPinCount: state.main.countryPinCount,

    // modal controllers
    isPinFullViewModalOpen: state.modals.isPinFullViewModalOpen,
    modalType: state.modals.modalType
});

export default connect(mapStateToProps, {
    loginTemp,
    openPinModal,
    openSubmitModalRequest,
    openParticipateModal,
    openBandFinderPinModal,
    getUserLocation,
    closePinFullViewModal,
    openPinFullViewModal,
    updateFilters,
    incPinViewCount
})(Mosaic);



// WEBPACK FOOTER //
// ./src/Components/Main/Mosaic.js